import axiosZendesk from '@/plugins/axios.zendesk.plugin';
import axiosPlataforma from '@/plugins/axios.plataforma.plugin';

export default {
  getScreenInformation(topicId) {
    return axiosPlataforma.custAxios().get(`/content/topic/${topicId}/zendesk-report`);
  },
  registerZendeskTicket(params) {
    return axiosZendesk.customAxios().post('/zendesk/ticket', params);
  }
};
